module.exports = __webpack_public_path__ + "static/media/idbi_trustee2.ad92a966.png";